function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import ReactDOM from 'react-dom';
import React from 'react';
import '@wolffun/analytics';
import { useUpdateCurrencyExchangeRate } from '@wolffun/system-currency';
import { ENV, INTERNAL } from '@wolffun/env-var';
import { Provider } from 'react-redux';
import { Router, Route, Switch, useLocation } from 'react-router-dom';
import { appHistory } from '@wolffun/app-manager';
import routes, { preloadRoutes } from './routes';
import store from './redux/store';
import * as Sentry from '@sentry/react';
import initializeSentry from './utils/sentry';
import Header from './Components/Header_V2';
import Footer from './Components/Footer_V2'; // Initialize sentry

initializeSentry({
  history: appHistory.history
});
const SentryRoute = Sentry.withSentryRouting(Route);
import './global.scss';
import 'src/utils/dayjs';
import NotificationProvider from '@conversionProgram/src/ConvertPage/NotificationProvider';
import CalloutProvider from './Components/CalloutProvider';
import { logVisitPageDB } from './redux/api';
import { defaultConfig, getAppConfig } from '@wolffun/app-config';
import { loadInjectors } from './utils/appInjector';
const ESTIMATED_TIME_LOAD_COMPLETED = 2000;

const App = () => {
  useUpdateCurrencyExchangeRate();
  React.useLayoutEffect(() => {
    if (!INTERNAL) return undefined;
    const envBadgeLink = window.document.getElementById('env-badge-link');
    const envBadge = window.document.getElementById('env-badge');
    const boxMessage = window.document.getElementById('message');
    const boxMessageText = window.document.getElementById('message-content-text');
    const configs = getAppConfig();

    if (envBadgeLink) {
      envBadgeLink.innerText = ENV;
    }

    if (envBadge && boxMessage && boxMessageText && configs !== defaultConfig) {
      envBadge.classList.add('hide');
      boxMessage.classList.add('show');
      boxMessageText.innerText = 'Configs has change';
      const deleteMessage = setTimeout(() => {
        envBadge.classList.remove('hide');
        boxMessage.classList.remove('show');
        boxMessageText.innerText = '';
      }, 4000);
      return () => clearTimeout(deleteMessage);
    }

    return undefined;
  }, []);
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(Router, {
    history: appHistory.history
  }, /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(NotificationProvider, null, /*#__PURE__*/React.createElement(Main, null)))));
};

const Main = () => {
  const location = useLocation();
  React.useEffect(() => {
    const id = setTimeout(() => {
      preloadRoutes();
    }, ESTIMATED_TIME_LOAD_COMPLETED);
    return () => clearTimeout(id);
  }, []);
  React.useEffect(() => {
    loadInjectors({
      history: appHistory.history,
      store: store
    });
  }, []);
  React.useEffect(() => {
    logVisitPageDB({
      domain: window.location.hostname,
      path: location.pathname,
      ua: navigator.userAgent,
      at: Math.floor(Date.now() / 1000)
    });
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CalloutProvider, null, /*#__PURE__*/React.createElement(Header, null)), /*#__PURE__*/React.createElement(Switch, null, routes.map(route => /*#__PURE__*/React.createElement(SentryRoute, _extends({}, route, {
    key: route.key
  })))), /*#__PURE__*/React.createElement(Footer, null));
};

ReactDOM.render( /*#__PURE__*/React.createElement(App, null), document.getElementById('app'));